/**
 * 패스 지급 시나리오 프리셋 → adminGrantPass opts 번역.
 *
 * 상점 "기존" 서브탭 노출 게이트는
 *   isActive || (claimedLevel + 1 <= unlockedLevel && <= totalLevels)
 * 이므로, 만료 여부와 미수령 잔여 유무가 시나리오를 가른다.
 */
export type PassGrantPreset = 'fresh' | 'aged' | 'expired_unclaimed' | 'expired_claimed';

export interface PassMetaSummary {
  durationDays: number;
  trackLength: number;
}

const DEFAULT_DURATION_DAYS = 30;

/**
 * clientProducts 산출물의 metadata(JSON 문자열)에서 프리셋 계산에 필요한 값만 뽑는다.
 *
 * @throws {SyntaxError} metadataJson 이 malformed JSON 이면 `JSON.parse` 가 그대로 던진다
 *   (별도로 감싸지 않음 — 호출부가 try/catch 로 처리해야 한다).
 */
export function readPassMeta(metadataJson: string): PassMetaSummary {
  const meta = JSON.parse(metadataJson) as {
    durationDays?: number;
    passTrack?: unknown[];
  };
  return {
    durationDays:
      typeof meta.durationDays === 'number' && meta.durationDays > 0
        ? meta.durationDays
        : DEFAULT_DURATION_DAYS,
    trackLength: Array.isArray(meta.passTrack) ? meta.passTrack.length : 0,
  };
}

export function presetToOpts(
  preset: PassGrantPreset,
  meta: PassMetaSummary,
  agedDays: number
): { elapsedDays: number; claimedLevel: number } {
  switch (preset) {
    case 'fresh':
      return { elapsedDays: 0, claimedLevel: 0 };
    case 'aged':
      return { elapsedDays: agedDays, claimedLevel: 0 };
    case 'expired_unclaimed':
      // utcDayExpiry(now, d) = (dayIndex(now) + d) * DAY_MS 라 d일 되감으면
      // expiresAt = 오늘 UTC 자정 < now → 확실히 만료된다.
      return { elapsedDays: meta.durationDays, claimedLevel: 0 };
    case 'expired_claimed':
      // durationDays < trackLength 인 상품은 서버가 unlockedLevel 로 클램프한다.
      // 그 경우에도 nextClaim > unlockedLevel 이라 서브탭 소멸 조건은 충족된다.
      return { elapsedDays: meta.durationDays, claimedLevel: meta.trackLength };
  }
}
